module.exports = __webpack_public_path__ + "static/img/AS.296fa30f.svg";